var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H12V1.5C12 0.672813 11.3281 0 10.5 0H5.5C4.67188 0 4 0.672813 4 1.5V3H2C0.895313 3 0 3.89687 0 5V13C0 14.1047 0.895313 15 2 15H14C15.1047 15 16 14.1047 16 13V5C16 3.89687 15.1031 3 14 3ZM5 1.5C5 1.22406 5.225 1 5.5 1H10.5C10.775 1 11 1.22406 11 1.5V3H5V1.5ZM15 13C15 13.5513 14.5513 14 14 14H2C1.44875 14 1 13.5513 1 13V9H5.5V11C5.5 11.2764 5.72363 11.5 6 11.5H10C10.2764 11.5 10.5 11.2764 10.5 11V9H15V13ZM6.5 10.5V9H9.5V10.5H6.5ZM15 8H1V5C1 4.44875 1.44875 4 2 4H14C14.5513 4 15 4.44875 15 5V8Z",
    fill: "#F26687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.3aca8663ffd16f9a03eb395956eef1ce.svg";
export { ForwardRef as ReactComponent };